import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="Footer">
      <a
        href="https://github.com/claude-rose/weather-app-react"
        target="_blank"
        rel="noreferrer"
      >
        Open-source code
      </a>{" "}
      by{" "}
      <a
        href="https://stupefied-rosalind-939d58.netlify.app/"
        target="_blank"
        rel="noreferrer"
      >
        Claudia Cross
      </a>
    </footer>
  );
}
